var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booked-item"},[_c('span',{staticClass:"booked-item__time",class:{
      'booked-item__time-now': _vm.isToday
    }},[_vm._v(_vm._s(_vm.date))]),_vm._l((_vm.bookings),function(booking){return _c('BookedItemDetails',{key:booking.booking_id,attrs:{"booking":booking,"mode":_vm.mode}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }